import { createAction } from '../../utils/createAction';

import {
  IOnDeltaReceivedAction,
  ISyncStateCommitAction,
  ISyncStateResetAction,
  IUpdateConflictStateAction,
  ISyncHealthAction,
  ISyncReconcileAction,
  ON_DELTA_RECEIVED,
  SYNC_CMD_DISABLE,
  SYNC_CMD_ENABLE,
  SYNC_HEALTH,
  LOGOUT_INTENT,
  SYNC_RECONCILE,
  SYNC_STATE_COMMIT,
  SYNC_STATE_RESET,
  UPDATE_CONFLICT_STATE,
} from './sync.types';

export const actOnDeltaReceived = createAction<IOnDeltaReceivedAction>(ON_DELTA_RECEIVED);

// Control-plane статусная модель (§2.8).
export const resetSyncState = createAction<ISyncStateResetAction>(SYNC_STATE_RESET);
export const commitSyncState = createAction<ISyncStateCommitAction>(SYNC_STATE_COMMIT);

// Control-plane команды/триггеры супервизора (§2.7).
export const syncReconcile = createAction<ISyncReconcileAction>(SYNC_RECONCILE);
export const syncCmdEnable = createAction(SYNC_CMD_ENABLE);
export const syncCmdDisable = createAction(SYNC_CMD_DISABLE);
export const syncHealth = createAction<ISyncHealthAction>(SYNC_HEALTH);
export const logoutIntent = createAction(LOGOUT_INTENT);

export const updateConflictState = createAction<IUpdateConflictStateAction>(UPDATE_CONFLICT_STATE);
